module.exports = __webpack_public_path__ + "static/media/Team 1 ASSIMILATE Logo.ecdd3acf.jpeg";